module.exports = __webpack_public_path__ + "static/media/lato-v15-latin-300.656963c4.woff";